import {TEAL_600} from '@wandb/weave/common/css/globals.styles';
import {TextField} from '@wandb/weave/components/Form/TextField';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 4px;
`;
LabelRow.displayName = 'S.LabelRow';

export const Label = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
`;
Label.displayName = 'S.Label';

export const InlineBlockAction = styled.div`
  display: flex;
  align-items: center;
`;
InlineBlockAction.displayName = 'S.InlineBlockAction';

export const InlineBlockActionLeft = styled.div`
  flex: 1 0;
`;
InlineBlockActionLeft.displayName = 'S.InlineBlockActionLeft';

export const InlineBlockActionRight = styled.div`
  flex: 0 1;
`;
InlineBlockActionRight.displayName = 'S.InlineBlockActionRight';

export const AddFilter = styled.span`
  display: inline-block;
  font-weight: 600;
  margin-top: 24px;
  color: ${TEAL_600};
`;
AddFilter.displayName = 'S.AddFilter';

export const DeleteFilter = styled.div`
  height: 20px;
  width: 20px;
  margin-left: 8px;
`;
DeleteFilter.displayName = 'S.DeleteFilter';

export const StyledTextField = styled(TextField)`
  font-family: 'Source Sans Pro';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`;
StyledTextField.displayName = 'S.StyledTextField';
